const number = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const hamKaasBatchRest = (batch, entries = []) => {
  const used = entries.reduce((total, entry) => {
    const lots = Array.isArray(entry?.hamkaasLots) ? entry.hamkaasLots : [];
    if (lots.length) {
      return total + lots.reduce((lotTotal, lot) => (
        String(lot?.batchId || "") === String(batch?.id || "")
          ? lotTotal + number(lot.kg)
          : lotTotal
      ), 0);
    }
    if (String(entry?.hamkaasBatchId || "") !== String(batch?.id || "")) return total;
    return total + number(entry.hamkaasKg);
  }, 0);
  return number(batch?.kg) + number(batch?.correctie) - used;
};

export const hamKaasBatchOptions = (batches = [], entries = [], naam = "") => (
  batches
    .filter((batch) => batch?.naam === naam)
    .map((batch) => ({
      ...batch,
      rest: hamKaasBatchRest(batch, entries),
    }))
    .filter((batch) => batch.rest > 0.001)
    .sort((left, right) => (
      String(left.datum || "").localeCompare(String(right.datum || ""))
      || String(left.tracecode || "").localeCompare(String(right.tracecode || ""))
    ))
);